import { apiClient } from "./httpClient";
import { unwrapEnvelope } from "./response";

export const dashboardApi = {
  async stats(params = {}) {
    const response = await apiClient.get("/dashboard-stats", { params });
    return unwrapEnvelope(response.data, {});
  },

  async revenueTrend(params = {}) {
    const response = await apiClient.get("/analytics/trends/revenue", { params });
    return unwrapEnvelope(response.data, { items: [] });
  },

  async approvalTrend(params = {}) {
    const response = await apiClient.get("/analytics/trends/approvals", { params });
    return unwrapEnvelope(response.data, { items: [] });
  }
};
